// Acronyms that should stay fully uppercase after Title Casing.
const ACRONYMS = new Set([
  'ID',
  'IDS',
  'OS',
  'IP',
  'URL',
  'URI',
  'CPI',
  'EPP',
  'CVE',
  'API',
  'SLA',
  'SSO',
  'MFA',
  'AWS',
  'GCP',
  'UI',
  'UX',
  'IDP',
  'DNS',
  'PII',
  'SIEM',
  'SOC',
  'NIST',
  'HIPAA',
  'PCI',
  'UUID',
  'MAC'
])

export const formatHeaderLabel = (raw: string): string => {
  if (!raw) return raw
  return raw
    .replace(/[_-]+/g, ' ')
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => {
      const upper = word.toUpperCase()
      if (ACRONYMS.has(upper)) return upper
      const lower = word.toLowerCase()
      return lower.charAt(0).toUpperCase() + lower.slice(1)
    })
    .join(' ')
}
